import React, { type ReactNode } from 'react';

interface FormProps {
  children: ReactNode;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

const Form = ({ children, onSubmit }: FormProps) => (
  <form onSubmit={onSubmit} noValidate>
    {children}
  </form>
);

export default Form;
export type { FormProps };
